import { DataTable } from '../../common/DataTable';
import type { ExchangeRate } from '../../../models/ExchangeRate';

export const ExchangeRateHistory = ({ items }: { items: ExchangeRate[] }) => (
  <DataTable
    items={items}
    columns={[
      { columnId: 'rate', label: 'Rate', renderCell: (item) => item.cr_crm_rate },
      { columnId: 'from', label: 'Effective from', renderCell: (item) => item.cr_crm_effectivefrom },
      { columnId: 'to', label: 'Effective to', renderCell: (item) => item.cr_crm_effectiveto ?? 'Current' },
      { columnId: 'source', label: 'Source', renderCell: (item) => item.cr_crm_source ?? '—' },
    ]}
    getRowId={(item) => item.cr_crm_exchangerateid}
    page={1}
    pageCount={1}
    totalItems={items.length}
    onPageChange={() => undefined}
  />
);
